import { graphql } from "@cappelendamm/crystallize-types/subscriptions/gql";
import Logger from "@cappelendamm/logger";
export const updateSubscriptionContract = async ({ id, ...params }, { client }) => {
    Logger.log(`Updating subscription contract in Crystallize: ${id}`);
    const data = await client.subscriptions.request(graphql(`
      mutation UpdateSubscriptionContract(
        $id: ID!
        $input: UpdateSubscriptionContractInput!
      ) {
        subscriptionContracts {
          update(id: $id, input: $input) {
            id
          }
        }
      }
    `), { input: params, id });
    return data.subscriptionContracts.update.id;
};
